export enum FormState {
  BLOCKED = "BLOCKED",
  LOADING = "LOADING",
  AVAILABLE = "AVAILABLE",
  COMPLETE = "COMPLETE",
}
